<template>
	<div class="c-brand-track">
		<InputBrand
			label="Search for a existing brand"
			v-model="brand"
			:tracked="true"
		></InputBrand>
		<hr />
		<FormBrandCreate :brandId="brandId" @onSubmit="onSubmit"></FormBrandCreate>
	</div>
</template>

<script>
import InputBrand from '@swipekit/components/form/input-brand';
import FormBrandCreate from '@swipekit/components/form/form-brand-create.vue';

export default {
	components: {
		InputBrand,
		FormBrandCreate,
	},

	data: function () {
		return {
			brand: null,
		};
	},

	computed: {
		brandId: function () {
			if (this.brand) {
				return this.brand.id;
			} else {
				return null;
			}
		},
	},

	methods: {
		onSubmit: function (e) {
			console.log(e);
		},
	},
};
</script>

<style lang="scss">
.c-brand-track {
	position: relative;
	z-index: 1;
	margin-top: 1rem;

	strong {
		font-weight: 500;
	}

	hr {
		position: relative;
		margin-bottom: 0;

		&:after {
			background-color: transparent;
		}

		&:before {
			display: block;
			padding: 0.25rem;
			content: 'OR';
			position: absolute;
			z-index: 1;
			top: 4px;
			left: calc(50% - 15px);
			font-size: 1.125rem;
		}
	}
}
</style>
